import { ParticipantShiftsTable } from '../../../../../ui/features/shift-details/components/participant-details-tables/ParticipantShiftsTable';
import { StyledAccordionSummary } from '../../../../../ui/features/shift-details/components/participant-details-tables/StyledAccordionSummary';
import { useSingleParticipantDetailsAnalytics } from '../../../../../ui/features/shift-details/hooks/useSingleParticipantDetailsAnalytics';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Accordion, AccordionDetails, Box } from '@mui/material';
import React from 'react';
export const SingleParticipantDetails = ({ row, columns, missionId, defaultRowsPerPage, onSendMessageToVolunteers, onInnerTableRowClick, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [wasExpanded, setWasExpanded] = React.useState(false);
    const { data: rowWithUpdatedAnalytics, fetchAnalytics } = useSingleParticipantDetailsAnalytics({
        row,
        participantId: row.participantId,
        missionId: missionId,
        isExpanded: isExpanded || wasExpanded,
    });
    const sharedStyles = (flex = 1) => {
        return {
            flex,
            color: themeColors.text.subtle,
        };
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordion, { sx: {
                boxShadow: 'none',
                border: `1px solid ${themeColors.border.main}`,
                borderRadius: 1,
                '::before': { opacity: 0 },
            } },
            React.createElement(StyledAccordionSummary, { onClick: () => {
                    setWasExpanded(true);
                    return setIsExpanded(!isExpanded);
                } },
                React.createElement(Box, { sx: {
                        display: 'flex',
                        width: '100%',
                        alignItems: 'center',
                    } },
                    React.createElement(Box, { sx: { flex: 2 } }, (_b = (_a = columns === null || columns === void 0 ? void 0 : columns[0]) === null || _a === void 0 ? void 0 : _a.cellFunction) === null || _b === void 0 ? void 0 : _b.call(_a, rowWithUpdatedAnalytics)),
                    React.createElement(Box, { sx: sharedStyles() }, (_d = (_c = columns === null || columns === void 0 ? void 0 : columns[1]) === null || _c === void 0 ? void 0 : _c.cellFunction) === null || _d === void 0 ? void 0 : _d.call(_c, rowWithUpdatedAnalytics)),
                    React.createElement(Box, { sx: sharedStyles() }, (_f = (_e = columns === null || columns === void 0 ? void 0 : columns[2]) === null || _e === void 0 ? void 0 : _e.cellFunction) === null || _f === void 0 ? void 0 : _f.call(_e, rowWithUpdatedAnalytics)),
                    React.createElement(Box, { sx: sharedStyles() }, (_h = (_g = columns === null || columns === void 0 ? void 0 : columns[3]) === null || _g === void 0 ? void 0 : _g.cellFunction) === null || _h === void 0 ? void 0 : _h.call(_g, rowWithUpdatedAnalytics)))),
            React.createElement(AccordionDetails, null, isExpanded && (React.createElement(ParticipantShiftsTable, { row: row, totalRows: row.shifts, missionId: missionId, defaultRowsPerPage: defaultRowsPerPage, onSendMessageToVolunteers: onSendMessageToVolunteers, onRowClick: onInnerTableRowClick, fetchAnalytics: fetchAnalytics })))),
        React.createElement(Box, { display: 'flex', flexDirection: 'column', sx: { gap: 2, pt: 2, background: 'transparent' } })));
};
